/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from '@wordpress/block-editor';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */

import { Fragment } from '@wordpress/element';
import { InspectorControls, BlockControls, AlignmentControl, PanelColorSettings } from '@wordpress/block-editor';
import { RangeControl, PanelBody, TextControl,  __experimentalToggleGroupControl as ToggleGroupControl, __experimentalToggleGroupControlOption as ToggleGroupControlOption } from '@wordpress/components';
import ServerSideRender from '@wordpress/server-side-render';

export default function Edit( props ) {

	const { setAttributes, attributes } = props;
	const { textColor, backgroundColor, textColorHover, backgroundColorHover, buttonStyle, borderRadius, borderRadiusHover, buttonLabel } = attributes;

	return (
		<div { ...useBlockProps() }>
			<InspectorControls>
				<PanelBody title={ __( 'Book Button', 'wp-travel-blocks' ) } >
					<TextControl
						label={"Label"}
						value={buttonLabel}
						onChange={ value => setAttributes(
							{
								buttonLabel: value
							}
						) }
					/>
					<ToggleGroupControl label="Button Style" value={buttonStyle} isBlock onChange={ (buttonStyle) => setAttributes({ buttonStyle: buttonStyle }) }>
						<ToggleGroupControlOption value="normal" label="Normal" />
						<ToggleGroupControlOption value="hover" label="Hover" />
					</ToggleGroupControl>
					{
						buttonStyle == "normal" &&
						<Fragment>
							<PanelColorSettings
								className={'custom-book-button-panel-style'}
								colorSettings={[
									{
										value: textColor,
										onChange: colorValue => setAttributes({ textColor: colorValue }),
										label: __( 'Text Color', 'wp-travel-blocks' )
									},
									{
										value: backgroundColor,
										onChange: colorValue => setAttributes({ backgroundColor: colorValue }),
										label: __( 'Background Color', 'wp-travel-blocks' )
									}
								]}
								initialOpen={false}
							/>
							<RangeControl
								label={__('Border Radius', 'wp-travel-blocks')}
								onChange={ (value) => setAttributes( { borderRadius: value } ) }
								shiftStep={ 1 }
								min={ 2 }
								max={ 100 }
								value={ borderRadius }
							/>
						</Fragment>
					}
					{
						buttonStyle == "hover" &&
						<Fragment>
							<PanelColorSettings
								className={'custom-book-button-panel-style'}
								colorSettings={[
									{
										value: textColorHover,
										onChange: colorValue => setAttributes({ textColorHover: colorValue }),
										label: __( 'Text Color', 'wp-travel-blocks' )
									},
									{
										value: backgroundColorHover,
										onChange: colorValue => setAttributes({ backgroundColorHover: colorValue }),
										label: __( 'Background Color', 'wp-travel-blocks' )
									}
								]}
								initialOpen={false}
							/>
							<RangeControl
								label={__('Border Radius', 'wp-travel-blocks')}
								onChange={ (value) => setAttributes( { borderRadiusHover: value } ) }
								shiftStep={ 1 }
								min={ 2 }
								max={ 100 }
								value={ borderRadiusHover }
							/>
						</Fragment>
					}
				</PanelBody>
			</InspectorControls>
			<ServerSideRender
				block="wp-travel-blocks/book-button"
				attributes={ props.attributes }
			/>
		</div>
	);
}
